"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_TYPES_SELECT_OPTIONS = exports.standardizeDocTypes = exports.getDocumentTypeByKey = exports.getDocumentTypeOption = exports.createDocumentTypeOptions = exports.DocumentTypeLabelMap = exports.DOCUMENT_TYPES = void 0;
// eslint-disable-next-line @typescript-eslint/naming-convention
var DOCUMENT_TYPES;
(function (DOCUMENT_TYPES) {
    DOCUMENT_TYPES["APPLICATION_SIGNED"] = "Application - signed";
    DOCUMENT_TYPES["APPLICATION_UNSIGNED"] = "Application - unsigned";
    DOCUMENT_TYPES["AUDIT_REQUEST_FORM"] = "Audit Request Form";
    DOCUMENT_TYPES["AUDIT_STATEMENT"] = "Audit Statement";
    DOCUMENT_TYPES["AUTO_ID_CARD"] = "Auto ID card";
    DOCUMENT_TYPES["BIND_CONFIRMATION"] = "Bind Confirmation";
    DOCUMENT_TYPES["BIND_ORDER"] = "Bind Order";
    DOCUMENT_TYPES["BOR"] = "Broker of Record";
    DOCUMENT_TYPES["BINDER"] = "Binder";
    DOCUMENT_TYPES["BLANKET_BOR_LETTER_SIGNED"] = "Blanket BOR Letter - signed";
    DOCUMENT_TYPES["BLANKET_BOR_LOSS_RUNS_LETTER_SIGNED"] = "Blanket BOR & Loss Runs Letter - signed";
    DOCUMENT_TYPES["BLANKET_LOSS_RUNS_LETTER_SIGNED"] = "Blanket Loss Runs Letter - signed";
    DOCUMENT_TYPES["BOR_CONFIRMATION"] = "BOR Confirmation";
    DOCUMENT_TYPES["BOR_LETTER_SIGNED"] = "BOR Letter - signed";
    DOCUMENT_TYPES["BOR_LETTER_UNSIGNED"] = "BOR Letter - unsigned";
    DOCUMENT_TYPES["BROCHURE_PAMPHLET"] = "Brochure/Pamphlet";
    DOCUMENT_TYPES["CANCELLATION_CONFIRMATION"] = "Cancellation Confirmation";
    DOCUMENT_TYPES["CAP_TABLE"] = "Cap Table";
    DOCUMENT_TYPES["CERTIFICATE_HOLDER_LIST"] = "Certificate Holder List";
    DOCUMENT_TYPES["CERTIFICATE_OF_INSURANCE"] = "Certificate of insurance";
    DOCUMENT_TYPES["CLAIM"] = "Claim";
    DOCUMENT_TYPES["CONTRACT"] = "Contract";
    DOCUMENT_TYPES["COVERAGE_COMPARISON"] = "Coverage Comparison";
    DOCUMENT_TYPES["D_1_SIGNED"] = "D-1 - signed";
    DOCUMENT_TYPES["D_1_UNSIGNED"] = "D-1 - unsigned";
    DOCUMENT_TYPES["DECLINATION"] = "Declination";
    DOCUMENT_TYPES["DIRECTOR_OR_OFFICER_WAIVER_SIGNED"] = "Director or Officer Waiver - signed";
    DOCUMENT_TYPES["EMAIL"] = "Email";
    DOCUMENT_TYPES["EMPLOYEE_HANDBOOK"] = "Employee Handbook";
    DOCUMENT_TYPES["ENDORSEMENT"] = "Endorsement";
    DOCUMENT_TYPES["EXPERIENCE_MODIFICATION_RATING"] = "Experience Modification Rating";
    DOCUMENT_TYPES["EXPIRATION_NOTICE"] = "Expiration Notice";
    DOCUMENT_TYPES["EXPOSURE_REPORT"] = "Exposure Report";
    DOCUMENT_TYPES["FINANCIALS"] = "Financials";
    DOCUMENT_TYPES["FIRST_NOTICE_OF_LOSS"] = "First Notice of Loss";
    DOCUMENT_TYPES["INSPECTION_REQUEST"] = "Inspection Request";
    DOCUMENT_TYPES["INSPECTION_RESULTS"] = "Inspection Results";
    DOCUMENT_TYPES["INSPECTION_REPORT"] = "Inspection Report";
    DOCUMENT_TYPES["INVOICE"] = "Invoice";
    DOCUMENT_TYPES["IVANS_DOCUMENT"] = "Ivans Document";
    DOCUMENT_TYPES["LETTER_OF_REPRESENTATION"] = "Letter of Representation";
    DOCUMENT_TYPES["LOSS_RUNS"] = "Loss Runs";
    DOCUMENT_TYPES["LOSS_RUNS_AUTHORIZATION_LETTER_SIGNED"] = "Loss Runs Authorization Letter - signed";
    DOCUMENT_TYPES["LOST_POLICY_RELEASE_SIGNED"] = "Lost Policy Release - signed";
    DOCUMENT_TYPES["LOST_POLICY_RELEASE_UNSIGNED"] = "Lost Policy Release - unsigned";
    DOCUMENT_TYPES["MAPS_DIAGRAMS"] = "Maps/Diagrams";
    DOCUMENT_TYPES["MARKETING_SUMMARY"] = "Marketing Summary";
    DOCUMENT_TYPES["MOTOR_VEHICLE_REPORT"] = "Motor Vehicle Report (MVR)";
    DOCUMENT_TYPES["NARRATIVE"] = "Narrative";
    DOCUMENT_TYPES["NEWFRONT_COMPENSATION_DISCLOSURE_SIGNED"] = "Newfront Compensation Disclosure - signed";
    DOCUMENT_TYPES["NEWFRONT_COMPENSATION_DISCLOSURE_UNSIGNED"] = "Newfront Compensation Disclosure - unsigned";
    DOCUMENT_TYPES["NO_KNOWN_LOSS_LETTER"] = "No Known Loss Letter";
    DOCUMENT_TYPES["NO_KNOWN_LOSS_LETTER_SIGNED"] = "No Known Loss Letter - signed";
    DOCUMENT_TYPES["NON_RENEWAL"] = "Non-Renewal";
    DOCUMENT_TYPES["NOTES"] = "Notes";
    DOCUMENT_TYPES["NOTICE_OF_CANCELLATION"] = "Notice of Cancellation";
    DOCUMENT_TYPES["NOTICE_OF_CONDITIONAL_RENEWAL"] = "Notice of Conditional Renewal";
    DOCUMENT_TYPES["OFFICER_WAIVER_UNSIGNED"] = "Officer Waiver - unsigned";
    DOCUMENT_TYPES["OTHER"] = "Other";
    DOCUMENT_TYPES["PICTURE"] = "PICTURE";
    DOCUMENT_TYPES["POLICY"] = "Policy";
    DOCUMENT_TYPES["PREMIUM_FINANCE_AGREEMENT_SIGNED"] = "Premium Finance Agreement - signed";
    DOCUMENT_TYPES["PREMIUM_FINANCE_AGREEMENT_UNSIGNED"] = "Premium Finance Agreement - unsigned";
    DOCUMENT_TYPES["PRIOR_TERM_APPLICATION"] = "Prior Term Application";
    DOCUMENT_TYPES["PROOF_OF_PAYMENT"] = "Proof of payment";
    DOCUMENT_TYPES["PROPOSAL"] = "Proposal";
    DOCUMENT_TYPES["PROPOSAL_ACCEPTANCE_DISCLOSURE_FORM_SIGNED"] = "Proposal Acceptance Disclosure Form - signed";
    DOCUMENT_TYPES["PROPOSAL_ACCEPTANCE_DISCLOSURE_FORM_UNSIGNED"] = "Proposal Acceptance Disclosure Form - unsigned";
    DOCUMENT_TYPES["QUOTE"] = "Quote";
    DOCUMENT_TYPES["RATE_EXPOSURE_COMPARISON"] = "Rate/Exposure Comparison";
    DOCUMENT_TYPES["RATING_WORKSHEET"] = "Rating worksheet";
    DOCUMENT_TYPES["REINSTATEMENT"] = "Reinstatement";
    DOCUMENT_TYPES["REQUEST_FOR_LOSSES"] = "Request for Losses";
    DOCUMENT_TYPES["REQUEST_FOR_REINSTATEMENT"] = "Request for Reinstatement";
    DOCUMENT_TYPES["SAMPLE_CONTRACT"] = "Sample Contract";
    DOCUMENT_TYPES["SL_1_SIGNED"] = "SL-1 - signed";
    DOCUMENT_TYPES["SL_1_UNSIGNED"] = "SL-1 - unsigned";
    DOCUMENT_TYPES["SL_2_SIGNED"] = "SL-2 - signed";
    DOCUMENT_TYPES["SL_2_UNSIGNED"] = "SL-2 - unsigned";
    DOCUMENT_TYPES["SPECIMEN_FORMS"] = "Specimen Forms";
    DOCUMENT_TYPES["STATEMENT_OF_VALUES"] = "Statement of values";
    DOCUMENT_TYPES["SUMMARY_OF_INSURANCE"] = "Summary of Insurance";
    DOCUMENT_TYPES["SUMMONS_AND_COMPLAINT"] = "Summons and Complaint";
    DOCUMENT_TYPES["TRIA_SIGNED"] = "TRIA - signed";
    DOCUMENT_TYPES["TRIA_UNSIGNED"] = "TRIA - unsigned";
    DOCUMENT_TYPES["UNKNOWN"] = "Unknown";
    DOCUMENT_TYPES["WARRANTY_LETTER"] = "Warranty Letter";
    DOCUMENT_TYPES["WCIRB_INSPECTION"] = "WCIRB inspection";
    DOCUMENT_TYPES["WITNESS_STATEMENT"] = "Witness Statement";
})(DOCUMENT_TYPES = exports.DOCUMENT_TYPES || (exports.DOCUMENT_TYPES = {}));
exports.DocumentTypeLabelMap = (_a = {},
    _a[DOCUMENT_TYPES.PRIOR_TERM_APPLICATION] = 'Application - prior term',
    _a[DOCUMENT_TYPES.APPLICATION_SIGNED] = 'Application - signed',
    _a[DOCUMENT_TYPES.APPLICATION_UNSIGNED] = 'Application - unsigned',
    _a[DOCUMENT_TYPES.AUDIT_REQUEST_FORM] = 'Audit Request Form',
    _a[DOCUMENT_TYPES.AUDIT_STATEMENT] = 'Audit Statement',
    _a[DOCUMENT_TYPES.AUTO_ID_CARD] = 'Auto ID card',
    _a[DOCUMENT_TYPES.BIND_CONFIRMATION] = 'Bind Confirmation',
    _a[DOCUMENT_TYPES.BIND_ORDER] = 'Bind Order',
    _a[DOCUMENT_TYPES.BINDER] = 'Binder',
    _a[DOCUMENT_TYPES.BLANKET_BOR_LETTER_SIGNED] = 'Blanket BOR Letter - signed',
    _a[DOCUMENT_TYPES.BLANKET_BOR_LOSS_RUNS_LETTER_SIGNED] = 'Blanket BOR & Loss Runs Letter - signed',
    _a[DOCUMENT_TYPES.BLANKET_LOSS_RUNS_LETTER_SIGNED] = 'Blanket Loss Runs Letter - signed',
    _a[DOCUMENT_TYPES.BOR] = 'Broker of Record',
    _a[DOCUMENT_TYPES.BOR_CONFIRMATION] = 'BOR Confirmation',
    _a[DOCUMENT_TYPES.BOR_LETTER_SIGNED] = 'BOR Letter - signed',
    _a[DOCUMENT_TYPES.BOR_LETTER_UNSIGNED] = 'BOR Letter - unsigned',
    _a[DOCUMENT_TYPES.BROCHURE_PAMPHLET] = 'Brochure/Pamphlet',
    _a[DOCUMENT_TYPES.CANCELLATION_CONFIRMATION] = 'Cancellation Confirmation',
    _a[DOCUMENT_TYPES.CAP_TABLE] = 'Cap Table',
    _a[DOCUMENT_TYPES.CERTIFICATE_HOLDER_LIST] = 'Certificate Holder List',
    _a[DOCUMENT_TYPES.CERTIFICATE_OF_INSURANCE] = 'Certificate of insurance',
    _a[DOCUMENT_TYPES.CLAIM] = 'Claim',
    _a[DOCUMENT_TYPES.NOTICE_OF_CONDITIONAL_RENEWAL] = 'Conditional Renewal Notice',
    _a[DOCUMENT_TYPES.CONTRACT] = 'Contract',
    _a[DOCUMENT_TYPES.COVERAGE_COMPARISON] = 'Coverage Comparison',
    _a[DOCUMENT_TYPES.D_1_SIGNED] = 'D-1 - signed',
    _a[DOCUMENT_TYPES.D_1_UNSIGNED] = 'D-1 - unsigned',
    _a[DOCUMENT_TYPES.DECLINATION] = 'Declination',
    _a[DOCUMENT_TYPES.DIRECTOR_OR_OFFICER_WAIVER_SIGNED] = 'Officer waiver - signed',
    _a[DOCUMENT_TYPES.EMAIL] = 'Email',
    _a[DOCUMENT_TYPES.EMPLOYEE_HANDBOOK] = 'Employee Handbook',
    _a[DOCUMENT_TYPES.ENDORSEMENT] = 'Endorsement',
    _a[DOCUMENT_TYPES.EXPERIENCE_MODIFICATION_RATING] = 'Experience Modification Rating',
    _a[DOCUMENT_TYPES.EXPIRATION_NOTICE] = 'Expiration Notice',
    _a[DOCUMENT_TYPES.EXPOSURE_REPORT] = 'Exposure Report',
    _a[DOCUMENT_TYPES.FINANCIALS] = 'Financials',
    _a[DOCUMENT_TYPES.FIRST_NOTICE_OF_LOSS] = 'First Notice of Loss',
    _a[DOCUMENT_TYPES.INSPECTION_REPORT] = 'Inspection Report',
    _a[DOCUMENT_TYPES.INSPECTION_REQUEST] = 'Inspection Request',
    _a[DOCUMENT_TYPES.INSPECTION_RESULTS] = 'Loss control recomendations',
    _a[DOCUMENT_TYPES.INVOICE] = 'Invoice',
    _a[DOCUMENT_TYPES.IVANS_DOCUMENT] = 'Ivans document',
    _a[DOCUMENT_TYPES.LETTER_OF_REPRESENTATION] = 'Letter of Representation',
    _a[DOCUMENT_TYPES.LOSS_RUNS] = 'Loss Runs',
    _a[DOCUMENT_TYPES.LOSS_RUNS_AUTHORIZATION_LETTER_SIGNED] = 'Loss Runs Authorization Letter - signed',
    _a[DOCUMENT_TYPES.LOST_POLICY_RELEASE_SIGNED] = 'Lost Policy Release - signed',
    _a[DOCUMENT_TYPES.LOST_POLICY_RELEASE_UNSIGNED] = 'Lost Policy Release - unsigned',
    _a[DOCUMENT_TYPES.MAPS_DIAGRAMS] = 'Maps/Diagrams',
    _a[DOCUMENT_TYPES.MARKETING_SUMMARY] = 'Marketing Summary',
    _a[DOCUMENT_TYPES.MOTOR_VEHICLE_REPORT] = 'Motor Vehicle Report (MVR)',
    _a[DOCUMENT_TYPES.NARRATIVE] = 'Narrative',
    _a[DOCUMENT_TYPES.NEWFRONT_COMPENSATION_DISCLOSURE_SIGNED] = 'Newfront Compensation Disclosure - signed',
    _a[DOCUMENT_TYPES.NEWFRONT_COMPENSATION_DISCLOSURE_UNSIGNED] = 'Newfront Compensation Disclosure - unsigned',
    _a[DOCUMENT_TYPES.NO_KNOWN_LOSS_LETTER] = 'No Known Loss Letter',
    _a[DOCUMENT_TYPES.NO_KNOWN_LOSS_LETTER_SIGNED] = 'No Known Loss Letter - signed',
    _a[DOCUMENT_TYPES.NON_RENEWAL] = 'Non-Renewal',
    _a[DOCUMENT_TYPES.NOTES] = 'Notes',
    _a[DOCUMENT_TYPES.NOTICE_OF_CANCELLATION] = 'Notice of Cancellation',
    _a[DOCUMENT_TYPES.OFFICER_WAIVER_UNSIGNED] = 'Officer Waiver - unsigned',
    _a[DOCUMENT_TYPES.OTHER] = 'Other',
    _a[DOCUMENT_TYPES.POLICY] = 'Policy',
    _a[DOCUMENT_TYPES.PICTURE] = 'Picture',
    _a[DOCUMENT_TYPES.PREMIUM_FINANCE_AGREEMENT_SIGNED] = 'Premium Finance Agreement - signed',
    _a[DOCUMENT_TYPES.PREMIUM_FINANCE_AGREEMENT_UNSIGNED] = 'Premium Finance Agreement - unsigned',
    _a[DOCUMENT_TYPES.PROOF_OF_PAYMENT] = 'Proof of payment',
    _a[DOCUMENT_TYPES.PROPOSAL] = 'Proposal',
    _a[DOCUMENT_TYPES.PROPOSAL_ACCEPTANCE_DISCLOSURE_FORM_SIGNED] = 'Proposal Acceptance Disclosure Form - signed',
    _a[DOCUMENT_TYPES.PROPOSAL_ACCEPTANCE_DISCLOSURE_FORM_UNSIGNED] = 'Proposal Acceptance Disclosure Form - unsigned',
    _a[DOCUMENT_TYPES.QUOTE] = 'Quote',
    _a[DOCUMENT_TYPES.RATE_EXPOSURE_COMPARISON] = 'Rate/Exposure Comparison',
    _a[DOCUMENT_TYPES.RATING_WORKSHEET] = 'Rating worksheet',
    _a[DOCUMENT_TYPES.REINSTATEMENT] = 'Reinstatement',
    _a[DOCUMENT_TYPES.REQUEST_FOR_LOSSES] = 'Request for Losses',
    _a[DOCUMENT_TYPES.REQUEST_FOR_REINSTATEMENT] = 'Request for Reinstatement',
    _a[DOCUMENT_TYPES.SAMPLE_CONTRACT] = 'Sample Contract',
    _a[DOCUMENT_TYPES.SL_1_SIGNED] = 'SL-1 - signed',
    _a[DOCUMENT_TYPES.SL_1_UNSIGNED] = 'SL-1 - unsigned',
    _a[DOCUMENT_TYPES.SL_2_SIGNED] = 'SL-2 - signed',
    _a[DOCUMENT_TYPES.SL_2_UNSIGNED] = 'SL-2 - unsigned',
    _a[DOCUMENT_TYPES.SPECIMEN_FORMS] = 'Specimen Forms',
    _a[DOCUMENT_TYPES.STATEMENT_OF_VALUES] = 'Statement of values',
    _a[DOCUMENT_TYPES.SUMMARY_OF_INSURANCE] = 'Summary of Insurance',
    _a[DOCUMENT_TYPES.SUMMONS_AND_COMPLAINT] = 'Summons and Complaint',
    _a[DOCUMENT_TYPES.TRIA_SIGNED] = 'TRIA - signed',
    _a[DOCUMENT_TYPES.TRIA_UNSIGNED] = 'TRIA - unsigned',
    _a[DOCUMENT_TYPES.UNKNOWN] = 'Unknown',
    _a[DOCUMENT_TYPES.WARRANTY_LETTER] = 'Warranty Letter',
    _a[DOCUMENT_TYPES.WCIRB_INSPECTION] = 'WCIRB inspection',
    _a[DOCUMENT_TYPES.WITNESS_STATEMENT] = 'Witness Statement',
    _a);
/**
 * createDocumentTypeOptions
 * @param documentTypes - optional custom documentTypes
 * create options for a SelectInput
 */
var createDocumentTypeOptions = function (documentTypes) {
    var docTypes = documentTypes || Object.keys(exports.DocumentTypeLabelMap);
    var options = docTypes.map(function (documentType) { return ({
        value: documentType,
        label: exports.DocumentTypeLabelMap[documentType],
    }); });
    return options;
};
exports.createDocumentTypeOptions = createDocumentTypeOptions;
/**
 * getDocumentTypeOption
 * @param value - a value you wish to match
 * @param documentType - optional custom documentTypes
 * find a documentType in a list of documentTypes
 */
var getDocumentTypeOption = function (value, documentTypes) {
    if (!value)
        return 'Unknown';
    var docTypes = documentTypes || Object.values(DOCUMENT_TYPES);
    var found = docTypes.filter(function (type) { return type.toLowerCase() === value.toLowerCase(); });
    var result = found.length > 0 ? found[0] : 'Unknown';
    return result;
};
exports.getDocumentTypeOption = getDocumentTypeOption;
/**
 * getDocumentTypeByKey
 * @param value - a value you wish to match
 * find a documentType in a list of documentTypes by key
 */
var getDocumentTypeByKey = function (keyValue) {
    if (!keyValue)
        return 'Unknown';
    var type = DOCUMENT_TYPES[keyValue];
    var result = type !== null && type !== void 0 ? type : 'Unknown';
    return result;
};
exports.getDocumentTypeByKey = getDocumentTypeByKey;
/**
 * standardizeDocTypes
 * convert the casing of old doc type values to reflect the master doc types
 */
function standardizeDocTypes(docType) {
    switch (docType) {
        case 'application':
            return 'Application - unsigned';
        case 'Application - Signed':
            return 'Application - signed';
        case 'Application - Unsigned':
            return 'Application - unsigned';
        case 'Broker of Record':
            return 'BOR letter - unsigned';
        case 'certificate of insurance':
            return 'Certificate of Insurance';
        case 'D-1 - Signed':
            return 'D-1 - signed';
        case 'email':
            return 'Email';
        case 'Lost Policy Release - Signed':
            return 'Lost Policy Release - signed';
        case 'Loss Runs Authorization Letter - Signed':
            return 'Loss Runs Authorization Letter - signed';
        case 'No Known Loss Letter - Signed':
            return 'No Known Loss Letter - signed';
        case 'Officer Waiver - Signed':
            return 'Director or Officer Waiver - signed';
        case 'Proposal Acceptance Disclosure Form':
            return 'Proposal Acceptance Disclosure Form - unsigned';
        case 'techcanary_attachment':
            return 'Unknown';
        default:
            return docType;
    }
}
exports.standardizeDocTypes = standardizeDocTypes;
exports.DOCUMENT_TYPES_SELECT_OPTIONS = [
    {
        label: 'Application - signed',
        value: 'APPLICATION_SIGNED',
    },
    {
        label: 'Application - unsigned',
        value: 'APPLICATION_UNSIGNED',
    },
    {
        label: 'Audit Request Form',
        value: 'AUDIT_REQUEST_FORM',
    },
    {
        label: 'Audit Statement',
        value: 'AUDIT_STATEMENT',
    },
    {
        label: 'Bind Confirmation',
        value: 'BIND_CONFIRMATION',
    },
    {
        label: 'Bind Order',
        value: 'BIND_ORDER',
    },
    {
        label: 'Binder',
        value: 'BINDER',
    },
    {
        label: 'Blanket BOR Letter - signed',
        value: 'BLANKET_BOR_LETTER_SIGNED',
    },
    {
        label: 'Blanket BOR & Loss Runs Letter - signed',
        value: 'BLANKET_BOR_LOSS_RUNS_LETTER_SIGNED',
    },
    {
        label: 'Blanket Loss Runs Letter - signed',
        value: 'BLANKET_LOSS_RUNS_LETTER_SIGNED',
    },
    {
        label: 'BOR Confirmation',
        value: 'BOR_CONFIRMATION',
    },
    {
        label: 'BOR Letter - signed',
        value: 'BOR_LETTER_SIGNED',
    },
    {
        label: 'BOR Letter - unsigned',
        value: 'BOR_LETTER_UNSIGNED',
    },
    {
        label: 'Cancellation Confirmation',
        value: 'CANCELLATION_CONFIRMATION',
    },
    {
        label: 'Cap Table',
        value: 'CAP_TABLE',
    },
    {
        label: 'Certificate Holder List',
        value: 'CERTIFICATE_HOLDER_LIST',
    },
    {
        label: 'Certificate of insurance',
        value: 'CERTIFICATE_OF_INSURANCE',
    },
    {
        label: 'Claim',
        value: 'CLAIM',
    },
    {
        label: 'Contract',
        value: 'CONTRACT',
    },
    {
        label: 'Coverage Comparison',
        value: 'COVERAGE_COMPARISON',
    },
    {
        label: 'D-1 - signed',
        value: 'D_1_SIGNED',
    },
    {
        label: 'D-1 - unsigned',
        value: 'D_1_UNSIGNED',
    },
    {
        label: 'Declination',
        value: 'DECLINATION',
    },
    {
        label: 'Director or Officer Waiver - signed',
        value: 'DIRECTOR_OR_OFFICER_WAIVER_SIGNED',
    },
    {
        label: 'Email',
        value: 'EMAIL',
    },
    {
        label: 'Employee Handbook',
        value: 'EMPLOYEE_HANDBOOK',
    },
    {
        label: 'Endorsement',
        value: 'ENDORSEMENT',
    },
    {
        label: 'Experience Modification Rating',
        value: 'EXPERIENCE_MODIFICATION_RATING',
    },
    {
        label: 'Expiration Notice',
        value: 'EXPIRATION_NOTICE',
    },
    {
        label: 'Exposure Report',
        value: 'EXPOSURE_REPORT',
    },
    {
        label: 'Financials',
        value: 'FINANCIALS',
    },
    {
        label: 'First Notice of Loss',
        value: 'FIRST_NOTICE_OF_LOSS',
    },
    {
        label: 'Inspection Request',
        value: 'INSPECTION_REQUEST',
    },
    {
        label: 'Inspection Results',
        value: 'INSPECTION_RESULTS',
    },
    {
        label: 'Invoice',
        value: 'INVOICE',
    },
    {
        label: 'Letter of Representation',
        value: 'LETTER_OF_REPRESENTATION',
    },
    {
        label: 'Loss Runs',
        value: 'LOSS_RUNS',
    },
    {
        label: 'Loss Runs Authorization Letter - signed',
        value: 'LOSS_RUNS_AUTHORIZATION_LETTER_SIGNED',
    },
    {
        label: 'Lost Policy Release - signed',
        value: 'LOST_POLICY_RELEASE_SIGNED',
    },
    {
        label: 'Lost Policy Release - unsigned',
        value: 'LOST_POLICY_RELEASE_UNSIGNED',
    },
    {
        label: 'Marketing Summary',
        value: 'MARKETING_SUMMARY',
    },
    {
        label: 'Motor Vehicle Report (MVR)',
        value: 'MOTOR_VEHICLE_REPORT',
    },
    {
        label: 'Narrative',
        value: 'NARRATIVE',
    },
    {
        label: 'Newfront Compensation Disclosure - signed',
        value: 'NEWFRONT_COMPENSATION_DISCLOSURE_SIGNED',
    },
    {
        label: 'Newfront Compensation Disclosure - unsigned',
        value: 'NEWFRONT_COMPENSATION_DISCLOSURE_UNSIGNED',
    },
    {
        label: 'No Known Loss Letter',
        value: 'NO_KNOWN_LOSS_LETTER',
    },
    {
        label: 'No Known Loss Letter - signed',
        value: 'NO_KNOWN_LOSS_LETTER_SIGNED',
    },
    {
        label: 'Non-Renewal',
        value: 'NON_RENEWAL',
    },
    {
        label: 'Notice of Cancellation',
        value: 'NOTICE_OF_CANCELLATION',
    },
    {
        label: 'Notice of Conditional Renewal',
        value: 'NOTICE_OF_CONDITIONAL_RENEWAL',
    },
    {
        label: 'Officer Waiver - unsigned',
        value: 'OFFICER_WAIVER_UNSIGNED',
    },
    {
        label: 'Other',
        value: 'OTHER',
    },
    {
        label: 'Policy',
        value: 'POLICY',
    },
    {
        label: 'Premium Finance Agreement - signed',
        value: 'PREMIUM_FINANCE_AGREEMENT_SIGNED',
    },
    {
        label: 'Premium Finance Agreement - unsigned',
        value: 'PREMIUM_FINANCE_AGREEMENT_UNSIGNED',
    },
    {
        label: 'Prior Term Application',
        value: 'PRIOR_TERM_APPLICATION',
    },
    {
        label: 'Proof of payment',
        value: 'PROOF_OF_PAYMENT',
    },
    {
        label: 'Proposal',
        value: 'PROPOSAL',
    },
    {
        label: 'Proposal Acceptance Disclosure Form - signed',
        value: 'PROPOSAL_ACCEPTANCE_DISCLOSURE_FORM_SIGNED',
    },
    {
        label: 'Proposal Acceptance Disclosure Form - unsigned',
        value: 'PROPOSAL_ACCEPTANCE_DISCLOSURE_FORM_UNSIGNED',
    },
    {
        label: 'Quote',
        value: 'QUOTE',
    },
    {
        label: 'Rate/Exposure Comparison',
        value: 'RATE_EXPOSURE_COMPARISON',
    },
    {
        label: 'Rating worksheet',
        value: 'RATING_WORKSHEET',
    },
    {
        label: 'Reinstatement',
        value: 'REINSTATEMENT',
    },
    {
        label: 'Request for Losses',
        value: 'REQUEST_FOR_LOSSES',
    },
    {
        label: 'Request for Reinstatement',
        value: 'REQUEST_FOR_REINSTATEMENT',
    },
    {
        label: 'SL-1 - signed',
        value: 'SL_1_SIGNED',
    },
    {
        label: 'SL-1 - unsigned',
        value: 'SL_1_UNSIGNED',
    },
    {
        label: 'SL-2 - signed',
        value: 'SL_2_SIGNED',
    },
    {
        label: 'SL-2 - unsigned',
        value: 'SL_2_UNSIGNED',
    },
    {
        label: 'Specimen Forms',
        value: 'SPECIMEN_FORMS',
    },
    {
        label: 'Statement of values',
        value: 'STATEMENT_OF_VALUES',
    },
    {
        label: 'Summary of Insurance',
        value: 'SUMMARY_OF_INSURANCE',
    },
    {
        label: 'Summons and Complaint',
        value: 'SUMMONS_AND_COMPLAINT',
    },
    {
        label: 'TRIA - signed',
        value: 'TRIA_SIGNED',
    },
    {
        label: 'TRIA - unsigned',
        value: 'TRIA_UNSIGNED',
    },
    {
        label: 'Unknown',
        value: 'UNKNOWN',
    },
    {
        label: 'Warranty Letter',
        value: 'WARRANTY_LETTER',
    },
    {
        label: 'WCIRB inspection',
        value: 'WCIRB_INSPECTION',
    },
    {
        label: 'Witness Statement',
        value: 'WITNESS_STATEMENT',
    },
];
